import React from 'react';

import { Form, SelectProps } from 'antd';

import { OrganizationOption } from 'core/lib/modules/organization/entities';
import OrganizationSelect, { OrganizationSelectProps } from 'utils/form/organizationSelect';

import { ListingEditableCellProps } from './types';

function ListingOrganizationSelect({
  dataIndex,
  rules,
  ...props
}: ListingEditableCellProps & OrganizationSelectProps & SelectProps<number>) {
  return (
    <Form.Item
      hasFeedback
      rules={rules}
      name={dataIndex}
      className="m-0"
      valuePropName="selectedOption"
      normalize={(option: OrganizationOption) => {
        return option ? { id: option.value, name: option.label } : null;
      }}
    >
      <OrganizationSelect {...props} />
    </Form.Item>
  );
}

export default ListingOrganizationSelect;
